"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TopActionBar = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var ProductTour_1 = require("../../ui/ProductTour");
var SearchButton_1 = require("../../ui/SearchButton");
var UiAction_1 = require("../../uiAction/UiAction");
var TopActionBar = function (props) {
    var searchButtonProps = props.searchButtonProps;
    var productTourSteps = props.productTourSteps;
    var hasValue = function (value) {
        return value !== undefined && value !== null && value.length > 0;
    };
    if (productTourSteps === undefined || productTourSteps === null) {
        productTourSteps = [];
    }
    props.actions.map(function (e, i) {
        if (hasValue(e.productTourText)) {
            var tourTarget_1 = "[data-tourid=product-tour--".concat(e.id.replace(".", "_"), "]");
            if (productTourSteps.find(function (e) { return e.target === tourTarget_1; }) === undefined) {
                productTourSteps.push({
                    target: tourTarget_1,
                    content: e.productTourText
                });
            }
        }
    });
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "top-action-bar container-fluid pr-0 z-index-high" }, { children: [(0, jsx_runtime_1.jsxs)("div", __assign({ className: "row mr-0 pr-0", style: { flex: "1" } }, { children: [(0, jsx_runtime_1.jsx)("div", __assign({ className: "top-action-bar__block col-8 py-2" }, { children: props.children })), (0, jsx_runtime_1.jsxs)("div", __assign({ className: "top-action-bar__block col-4 mr-0 pr-0 top-action-bar__block--right" }, { children: [props.actions.map(function (e) {
                                return ((0, jsx_runtime_1.jsx)("div", __assign({ className: "top-action-bar__action p2" }, { children: (0, jsx_runtime_1.jsx)(UiAction_1.UiActionComponent, { action: e }, e.id) }), e.id));
                            }), (0, jsx_runtime_1.jsx)(SearchButton_1.SearchButton, { onChange: searchButtonProps.onChange, placeholder: searchButtonProps.placeholder, value: searchButtonProps.value, className: (searchButtonProps.className || "") +
                                    " top-action-bar__action px-2", onClose: searchButtonProps.onClose, buttonType: searchButtonProps.buttonType })] }))] })), (0, jsx_runtime_1.jsx)(ProductTour_1.ProductTour, { steps: productTourSteps, showTour: props.showProductTour || false })] })));
};
exports.TopActionBar = TopActionBar;
